import type { Order, Address, Notification, UserProfile } from '../services/client.service';

export const mockUserProfile: UserProfile = {
    id: 1024,
    firstnames: 'Mamadou Ibrahim',
    lastname: 'Diallo',
    email: 'm.diallo@onapila-intl.com',
    phone: '+224 622 00 00 00',
    status: 'active',
    zone: { id: 12, name: 'Zone Conakry-Aéroport' }
};

export const mockClientOrders: Order[] = [
    {
        id: 901,
        code_suivi: 'ONAP-DXB-CKY-8832',
        statut: 'en_transit',
        type_livraison: 'Fret Aérien International',
        adresse_ramassage: 'Dubaï Mall Cargo Hub, Émirats Arabes Unis',
        adresse_livraison: 'Dixinn Commisariat, Près de laBluezone, Conakry, Guinée',
        prix_estime: 385000,
        distance_km: 5640,
        created_at: new Date(Date.now() - 2 * 3600000 * 12).toISOString(),
        livraisons: [
            {
                id: 4412,
                statut: 'en_route',
                livreur: { id: 88, firstnames: 'Amadou', lastname: 'Barry', phone: '+224 664 11 22 33' }
            }
        ]
    },
    {
        id: 902,
        code_suivi: 'ONAP-LOC-7721',
        statut: 'en_cours',
        type_livraison: 'Livraison Urbaine Express',
        adresse_ramassage: 'Boutique Alpha, Kaloum, Conakry',
        adresse_livraison: 'Villa 4, Kipé Centre Émetteur, Conakry, Guinée',
        prix_estime: 25000,
        distance_km: 14.5,
        created_at: new Date(Date.now() - 1800000).toISOString(),
        livraisons: [
            {
                id: 4413,
                statut: 'assigne',
                livreur: { id: 92, firstnames: 'Ousmane', lastname: 'Camara', phone: '+224 620 44 55 66' }
            }
        ]
    },
    {
        id: 903,
        code_suivi: 'ONAP-ABJ-CKY-1102',
        statut: 'livree',
        type_livraison: 'Transit Routier Inter-États',
        adresse_ramassage: 'Marché d\'Adjamé, Abidjan, Côte d\'Ivoire',
        adresse_livraison: 'Grand Marché de Madina, Conakry, Guinée',
        prix_estime: 750000,
        distance_km: 1150,
        created_at: '2026-06-01T10:00:00.000Z',
        livraisons: []
    }
];

export const mockClientAddresses: Address[] = [
    {
        id: 1,
        user_id: 1024,
        nom_adresse: 'Bureau Kaloum',
        adresse_complete: 'Immeuble Almamya, 3ème Étage, Kaloum',
        est_principale: true,
        point_repere: 'En face de la Banque Centrale (BCRG)',
        quartier: 'Almamya',
        ville: 'Conakry',
        pays: 'Guinée'
    },
    {
        id: 2,
        user_id: 1024,
        nom_adresse: 'Domicile Kipé',
        adresse_complete: 'Résidence Camayenne II, Rue KI-102',
        est_principale: false,
        point_repere: 'Derrière le Lycée Kipé',
        quartier: 'Kipé',
        ville: 'Conakry',
        pays: 'Guinée'
    }
];

export const mockNotifications: Notification[] = [
    {
        id: 501,
        titre: 'Dédouanement Réussi ✈️',
        message: 'Votre colis ONAP-DXB-CKY-8832 a passé l\'inspection douanière à l\'Aéroport de Conakry Gbessia.',
        est_lu: false,
        created_at: new Date(Date.now() - 3600000).toISOString()
    },
    {
        id: 502,
        titre: 'Livreur assigné',
        message: 'Ousmane Camara a récupéré votre colis local à Kaloum.',
        est_lu: true,
        created_at: new Date(Date.now() - 7200000).toISOString()
    }
];